import { gql, useQuery } from '@apollo/client';

export const PROFILE_QUERY = gql(`
  query Profile {
    profile {
      id
      firstName
      lastName
      identifier
      status
      createdAt
      updatedAt
      deletedAt
      roles {
        id
        name
        mainRole
        ordersPermissions
        financePermissions
        driversPermissions
        tariffPermissions
        communicationsPermissions
        status
      }
    }
  }
`);

export const useProfileQuery = () => {
  return useQuery(PROFILE_QUERY);
};
